module.exports = __webpack_public_path__ + "img/homepage-mms.2e7896aa.png";